import script from "./Career.vue?vue&type=script&setup=true&lang=js"
export * from "./Career.vue?vue&type=script&setup=true&lang=js"

import "./Career.vue?vue&type=style&index=0&id=fa74e370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa74e370"]])

export default __exports__